import { Card, CardContent } from "@/components/ui/card";
import { Metal, Purity, Unit, ValuationResult as ValuationResultType, GoldPurity, SilverPurity } from "@/lib/pricing";
import { GOLD_PURITIES, SILVER_PURITIES } from "@/lib/constants";

interface ValuationResultProps {
  result: ValuationResultType;
  selectedMetal: Metal;
  goldPurity: GoldPurity;
  silverPurity: SilverPurity;
  weight: string;
  unit: Unit;
}

export function ValuationResult({ 
  result, 
  selectedMetal, 
  goldPurity, 
  silverPurity, 
  weight, 
  unit 
}: ValuationResultProps) {
  const currentTimestamp = new Date().toLocaleString('it-IT');
  const currentPurity = selectedMetal === 'ORO' ? goldPurity : silverPurity;
  
  // Preparazione della descrizione della purezza
  let purityDescription = '';
  const displayPurity = String(currentPurity);
  
  if (selectedMetal === 'ORO') {
    if (currentPurity === '24 KT') purityDescription = ' (100% puro)';
    else if (currentPurity === '22 KT') purityDescription = ' (91.6% puro)';
    else if (currentPurity === '20 KT') purityDescription = ' (83.3% puro)';
    else if (currentPurity === '18 KT') purityDescription = ' (75% puro)';
    else if (currentPurity === '14 KT') purityDescription = ' (58.5% puro)';
    else if (currentPurity === '9 KT') purityDescription = ' (37.5% puro)';
    
    return (
      <Card className="border-2 border-primary/20">
        <CardContent className="pt-6">
          <div className="text-center">
            <div className="text-lg font-medium mb-1">Valore stimato</div>
            <div className="text-3xl font-bold">{result.formattedPrice}</div>
            <div className="text-sm text-muted-foreground mt-1">
              Calcolato il {currentTimestamp}
            </div>
          </div>
          
          <div className="mt-4 text-sm">
            <div className="flex justify-between py-1 border-b">
              <span>Metallo:</span>
              <span className="font-medium">{selectedMetal}</span>
            </div>
            <div className="flex justify-between py-1 border-b">
              <span>Purezza:</span>
              <span className="font-medium">
                {displayPurity}
                <span className="text-muted-foreground text-xs ml-1">{purityDescription}</span>
              </span>
            </div>
            <div className="flex justify-between py-1 border-b">
              <span>Peso:</span>
              <span className="font-medium">{weight} {unit}</span>
            </div>
            <div className="flex justify-between py-1">
              <span>Prezzo di mercato:</span>
              <span className="font-medium">€{result.purifiedPrice.toFixed(2)}/g</span>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  } else {
    // Per l'argento, aggiungiamo il simbolo ‰ per la visualizzazione
    let visualPurity = '';
    
    if (currentPurity === 'PURO') {
      visualPurity = '999‰';
      purityDescription = '';
    }
    else if (currentPurity === '925') {
      visualPurity = '925‰';
      purityDescription = '';
    }
    else if (currentPurity === '800') {
      visualPurity = '800‰';
      purityDescription = '';
    }
    
    return (
      <Card className="border-2 border-primary/20">
        <CardContent className="pt-6">
          <div className="text-center">
            <div className="text-lg font-medium mb-1">Valore stimato</div>
            <div className="text-3xl font-bold">{result.formattedPrice}</div>
            <div className="text-sm text-muted-foreground mt-1">
              Calcolato il {currentTimestamp}
            </div>
          </div>
          
          <div className="mt-4 text-sm">
            <div className="flex justify-between py-1 border-b">
              <span>Metallo:</span>
              <span className="font-medium">{selectedMetal}</span>
            </div>
            <div className="flex justify-between py-1 border-b">
              <span>Purezza:</span>
              <span className="font-medium">{visualPurity}</span>
            </div>
            <div className="flex justify-between py-1 border-b">
              <span>Peso:</span>
              <span className="font-medium">{weight} {unit}</span>
            </div>
            <div className="flex justify-between py-1">
              <span>Prezzo di mercato:</span>
              <span className="font-medium">€{result.purifiedPrice.toFixed(2)}/g</span>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }
}
